import type { DurationMeasure, PassType } from '@/types';
import { UNLIMITED_VALUE } from '@/constants/unlimited';

// `durationNumber === UNLIMITED_VALUE` encodes "no duration".
export type PassTemplateFormValues = {
  name: string;
  durationMeasure: DurationMeasure;
  durationNumber: string;
  credits: string;
  isUnlimitedCredits: boolean;
};

export const defaultTemplateFormValues: PassTemplateFormValues = {
  name: '',
  durationMeasure: 'Months',
  durationNumber: '1',
  credits: '',
  isUnlimitedCredits: false,
};

export const templateToFormValues = (template?: PassType | null): PassTemplateFormValues => {
  if (!template) return defaultTemplateFormValues;
  const { duration } = template;

  if (duration === null) {
    return {
      name: template.name,
      durationMeasure: defaultTemplateFormValues.durationMeasure,
      durationNumber: UNLIMITED_VALUE,
      credits: template.credits?.toString() ?? '',
      isUnlimitedCredits: template.credits === null,
    };
  }

  return {
    name: template.name,
    durationMeasure: duration.measure,
    durationNumber: duration.number.toString(),
    credits: template.credits?.toString() ?? '',
    isUnlimitedCredits: template.credits === null,
  };
};

export const templateFormToDraft = (values: PassTemplateFormValues): Omit<PassType, 'id'> => ({
  name: values.name.trim(),
  duration:
    values.durationNumber === UNLIMITED_VALUE
      ? null
      : {
          measure: values.durationMeasure,
          number: parseInt(values.durationNumber.trim(), 10),
        },
  credits: values.isUnlimitedCredits
    ? null
    : values.credits.trim()
      ? parseInt(values.credits.trim(), 10)
      : null,
});
